import type { ReactNode } from "react";
import { Pressable, Text, View } from "react-native";

export function Tab({
  value,
  children,
  active = false,
  onPress,
  theme = "light",
}: {
  value: string;
  children: ReactNode;
  active?: boolean;
  onPress?: () => void;
  theme?: "light" | "dark";
}) {
  void value;
  const text = active ? (theme === "dark" ? "text-white" : "text-forest") : theme === "dark" ? "text-white/45" : "text-forest/40";
  return (
    <Pressable className="px-5 py-2.5" onPress={onPress}>
      <Text className={`text-[11px] font-bold uppercase tracking-[0.1em] ${text}`}>{children}</Text>
      <View className={`-mb-px mt-1 h-[2px] ${active ? "bg-amber" : "bg-transparent"}`} />
    </Pressable>
  );
}
